import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import HeroSection from '../components/home/HeroSection';
import FeaturesSection from '../components/home/FeaturesSection';
import CategoriesSection from '../components/home/CategoriesSection';
import HowToSection from '../components/home/HowToSection';
import TemplatesSection from '../components/home/TemplatesSection';
import SlipsSection from '../components/home/SlipsSection';
import TestimonialsSection from '../components/home/TestimonialsSection';
import FAQSection from '../components/home/FAQSection';
import { HomeSEO } from '../components/layout/SEO';
import { usePageData } from '../contexts/DataContext';

const HomePage = () => {
  const { data: homePage } = usePageData('homePage');

  // Add padding to account for fixed navbar
  React.useEffect(() => {
    document.body.style.paddingTop = '50px';
    return () => {
      document.body.style.paddingTop = '0';
    };
  }, []);

  return (
    <HelmetProvider>
      <div className="home-page">
        <HomeSEO pageData={homePage} />
        <HeroSection />
        <FeaturesSection />
        <CategoriesSection />
        <HowToSection />
        <TemplatesSection />
        <SlipsSection />
        <TestimonialsSection />
        <FAQSection />
      </div>
    </HelmetProvider>
  );
};

export default HomePage;